import { render, staticRenderFns } from "./TipoServicosListagem.vue?vue&type=template&id=257d4b1f&scoped=true&"
import script from "./TipoServicosListagem.vue?vue&type=script&lang=js&"
export * from "./TipoServicosListagem.vue?vue&type=script&lang=js&"
import style0 from "./TipoServicosListagem.vue?vue&type=style&index=0&id=257d4b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d4b1f",
  null
  
)

export default component.exports